export default "__VITE_ASSET__D6HQ1nPT__"